if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        if (this.closest('quick-add-modal')) return;
        this.sourceButton = document.getElementById(this.dataset.sourceButtonId);
        this.button = this.querySelector('.sticky-atc__button');
        this.label = this.querySelector('.sticky-atc__label');
        this.spinner = this.querySelector('.loading__spinner');
        this.sourceOutOfView = false;
        if (!this.sourceButton || !this.button) return;
        this.sourceObserver = new MutationObserver(this.syncFromSource.bind(this));
        this.sourceObserver.observe(this.sourceButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        this.viewObserver = new IntersectionObserver(
          ([entry]) => {
            // Only count the button as "out of view" once it has scrolled off the TOP of
            // the viewport. Plain !isIntersecting is also true before the shopper has
            // reached the button, which made the bar appear on page load.
            const viewportTop = entry.rootBounds ? entry.rootBounds.top : 0;
            const scrolledPastTop = entry.boundingClientRect.bottom <= viewportTop;

            this.sourceOutOfView = !entry.isIntersecting && scrolledPastTop;
            this.updateVisibility();
          },
          { threshold: 0 }
        );
        this.viewObserver.observe(this.sourceButton);

        this.syncFromSource();
      }

      disconnectedCallback() {
        this.sourceObserver?.disconnect();
        this.viewObserver?.disconnect();
      }

      syncFromSource() {
        const isLoading = this.sourceButton.classList.contains('loading');
        const isBusy = this.sourceButton.getAttribute('aria-disabled') === 'true';
        const sourceLabel = this.sourceButton.querySelector('span');
        const labelText = sourceLabel?.textContent.trim();

        this.button.toggleAttribute('disabled', this.sourceButton.hasAttribute('disabled'));
        this.button.classList.toggle('loading', isLoading);
        this.spinner?.classList.toggle('hidden', !isLoading);

        if (isBusy) {
          this.button.setAttribute('aria-disabled', 'true');
        } else {
          this.button.removeAttribute('aria-disabled');
        }

        if (this.label && labelText) this.label.textContent = labelText;

        this.updateVisibility();
      }

      updateVisibility() {
        const isSourceUsable =
          !this.sourceButton.hasAttribute('disabled') && this.sourceButton.getClientRects().length > 0;
        this.classList.toggle('sticky-atc--visible', this.sourceOutOfView && isSourceUsable);
      }
    }
  );
}
